import { AutogenModelPermsUserGroup, AutogenRowPermsUserGroup } from "./autogen/AutogenModelPermsUserGroup";

export class ModelPermsUserGroup extends AutogenModelPermsUserGroup<RowPermsUserGroup> {
	constructor() {
		super(RowPermsUserGroup);
	}
}

export class RowPermsUserGroup extends AutogenRowPermsUserGroup {

}
